'use client'

import type { ReactNode } from 'react'
import { cx } from '../utils/cx'

interface FlagButtonProps {
  selected?: boolean
  onToggle?: () => void
  children?: ReactNode
  className?: string
}

export function FlagButton({ selected, onToggle, children, className }: FlagButtonProps) {
  return (
    <button type="button" className={cx('st-big-flag', selected && 'selected', className)} onClick={onToggle}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="square">
        <path d="M6 4 L6 22" />
        <path d="M6 4 L18 4 L16 8 L18 12 L6 12" />
      </svg>
      {children || (selected ? 'Picked' : 'Flag as pick')}
    </button>
  )
}
